var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileIcon = function SvgMobileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#151414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 8.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h4Zm-4 1.5c-.28 0-.5.22-.5.5v8c0 .28.22.5.5.5h4c.28 0 .5-.22.5-.5V8c0-.28-.22-.5-.5-.5h-4Z"
  }))));
};
export default SvgMobileIcon;